module.exports = __webpack_public_path__ + "img/mira-ava.ecf12bb.png";